<template>
<div id="systemSetting">
  <router-view></router-view>
</div>
</template>

<script>
export default {
  name: 'systemSetting'
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/roleAndPermission/index.vue